<template>
  <div class="page-header">
    <div class="header-content">
      <div class="header-info">
        <nav class="breadcrumb-nav" v-if="breadcrumbs && breadcrumbs.length">
          <template v-for="(crumb, index) in breadcrumbs">
            <router-link
              v-if="crumb.to"
              :key="`link-${index}`"
              :to="crumb.to"
              class="breadcrumb-link"
            >
              <i v-if="crumb.icon" :class="crumb.icon"></i>
              {{ crumb.label }}
            </router-link>
            <span v-else :key="`current-${index}`" class="breadcrumb-current">
              {{ crumb.label }}
            </span>
            <i
              v-if="index < breadcrumbs.length - 1"
              :key="`separator-${index}`"
              class="las la-angle-right breadcrumb-separator"
            ></i>
          </template>
        </nav>
        <h1 class="page-title ml-2">
          {{ title }}
        </h1>
        <p v-if="subtitle" class="page-subtitle ml-2">
          {{ subtitle }}
        </p>
      </div>
      <div v-if="$slots.actions" class="header-actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: null
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../index.scss';

.page-header {
  padding: 1.75rem 2rem 0.5rem;
  border-bottom: none;
  background: transparent;
  
  .header-content {
    max-width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
  }
  
  .header-info {
    flex: 1;
  }
  
  .header-actions {
    display: flex;
    gap: 1.5rem;
    align-items: center;
    flex-shrink: 0;
  }
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.9rem;
}

.breadcrumb-link {
  color: darken($color-primary, 30%);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: color 0.2s ease;
  
  &:hover {
    color: darken($color-primary, 20%);
    text-decoration: none;
    transform: none;
  }
  
  i {
    font-size: 1rem;
  }
}

.breadcrumb-separator {
  color: #adb5bd;
  font-size: 0.8rem;
}

.breadcrumb-current {
  color: #495057;
  font-weight: 500;
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #101828;
  letter-spacing: -0.03em;
  margin: 0.25rem 0 0.25rem 0;
  font-family: $brand-font-bold;
}

.page-subtitle {
  color: #718096;
  font-size: 1rem;
  margin: 0;
  font-family: $brand-font-regular;
}
</style>


